import { render, staticRenderFns } from "./GeoStudents.vue?vue&type=template&id=17ec112a&"
import script from "./GeoStudents.vue?vue&type=script&lang=js&"
export * from "./GeoStudents.vue?vue&type=script&lang=js&"
import style0 from "./GeoStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports